import { render, staticRenderFns } from "./AccessibilityTextHelperDropdown.vue?vue&type=template&id=6239afcc&scoped=true&"
import script from "./AccessibilityTextHelperDropdown.vue?vue&type=script&lang=js&"
export * from "./AccessibilityTextHelperDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AccessibilityTextHelperDropdown.vue?vue&type=style&index=0&id=6239afcc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6239afcc",
  null
  
)

export default component.exports